import React from 'react';

import { FlexRow } from 'ui-components/components/flex';

import { messages } from './messages';
import { ShipmentDetailsExpanderContent } from './shipment-details-expander-content';
import style from './style.module.less';
import { OrderOverviewSectionId } from '../../../fulfillment-plan/order-details-expanded-section-provider';
import ExpanderSection from '../../../tab-section/expander-section/expander-section';
import SectionTitle from '../../../tab-section/title';

export const ShipmentDetails = () => {
  return (
    <ExpanderSection
      ariaLabelMessageDescriptor={messages.expandableSectionAriaLabel}
      contentClassName={style['shipment-details-section-content']}
      headerContent={
        <FlexRow className={style['shipment-details-section-header']}>
          <SectionTitle messageDescriptor={messages.sectionTitle} />
        </FlexRow>
      }
      isFullHeightWhenExpanded
      sectionContent={<ShipmentDetailsExpanderContent />}
      sectionId={OrderOverviewSectionId.ShipmentDetails}
    />
  );
};
